import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll(
	'.block-hero-centered-carousel .swiper'
);

const setSlideScale = (block, placeholder) => {
	let offsetModifier = 40;

	if (document.body.clientWidth >= 768) {
		offsetModifier = 280;
	}

	block.style.setProperty(
		'--slideScale',
		(placeholder.offsetWidth - offsetModifier) / placeholder.offsetWidth
	);
};

const setCurrentSlideClass = (swiper) => {
	swiper.slides.forEach((slide) => {
		slide.classList.remove('swiper-slide-current');
	});

	const currentSlide = swiper.slides[swiper.activeIndex];

	if (currentSlide) {
		currentSlide.classList.add('swiper-slide-current');
	}
};

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const block = slider.closest('.block-hero-centered-carousel');
		const slides = slider.querySelectorAll('.swiper-slide');
		const placeholder = block.querySelector(
			'.block-hero-centered-carousel__placeholder'
		);

		setSlideScale(block, placeholder);

		const settings = {
			loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: -16,
			slidesPerView: document.body.clientWidth / placeholder.offsetWidth,
			centeredSlides: true,
			speed: 600,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			on: {
				beforeResize(swiper) {
					swiper.params.slidesPerView =
						document.body.clientWidth / placeholder.offsetWidth;

					setSlideScale(block, placeholder);
				},
				init(swiper) {
					setCurrentSlideClass(swiper);
					setTimeout(() => {
						slider.classList.add('swiper-loaded');
					}, 10);
				},
				slideChangeTransitionEnd(swiper) {
					setCurrentSlideClass(swiper);
				},
			},
			breakpoints: {
				768: {
					spaceBetween: -140,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
